<template>
  <div>
    <owner-temporary-actions :message="message" :tasks="tasks" :moc="moc" @close="$emit('close')" :important="important">
    </owner-temporary-actions>
  </div>
</template>

<script>
import OwnerTemporaryActions from '@/components/mocForm/OwnerTemporaryActions'
export default {
  data: () => ({
    unauthorizedExpiredDialog: true
  }),
  props: {
    fromDialog: {
      type: Boolean,
      default: false
    },
    message: {
      type: String
    },
    tasks: {
      type: Array
    },
    moc: {
      type: Object
    },
    important: {
      type: Boolean
    }
  },
  components: {
    OwnerTemporaryActions
  }
}
</script>

<style scoped></style>
